module.exports = __webpack_public_path__ + "img/move12.4092b4bd.jpg";